var map = {
	"./componentscom/blankspace/index.vue": "d500",
	"./componentscom/captiontext/index.vue": "c964",
	"./componentscom/commoditysearch/index.vue": "32c8",
	"./componentscom/drawernavigation/index.vue": "4c9e",
	"./componentscom/follow/index.vue": "995e",
	"./componentscom/graphicnavigation/index.vue": "71e1",
	"./componentscom/jumpminiprogram/index.vue": "1225",
	"./componentscom/listswitching/index.vue": "31f4",
	"./componentscom/magiccube/index.vue": "3dcf",
	"./componentscom/memberinformation/index.vue": "4d90",
	"./componentscom/notice/index.vue": "eb7f",
	"./componentscom/ordertab/index.vue": "7fc0",
	"./componentscom/overlay/index.vue": "8bfd",
	"./componentscom/partline/index.vue": "e47c",
	"./componentscom/pictureads/index.vue": "7e28",
	"./componentscom/richtext/index.vue": "4ed7",
	"./componentscom/storeinformation/index.vue": "2806",
	"./componentscom/storenotecard/index.vue": "2196",
	"./componentscom/suspension/index.vue": "c8b9",
	"./componentscom/tabBar/index.vue": "eab4",
	"./componentscom/videoss/index.vue": "11e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51c7";